// Утилиты для вычисления скидок и маржи

// Функция для вычисления скидки или маржи в процентах
const calculateSkidkaOrMarzha = (price, originalPrice, isMarzha) => {
  if (!originalPrice || isNaN(originalPrice) || originalPrice === 0) return '';
  if (!price || isNaN(price)) return '';
  const result = isMarzha
    ? Math.round((price / originalPrice - 1) * 100)
    : Math.round(100 - (price / originalPrice) * 100);
  return result === 0 ? '' : result;
};

// Функция для вычисления цены на основе скидки или маржи
// precision — количество знаков после запятой (0 для большинства материалов, 2 для газобетона/кирпича)
const calculatePriceFromSkidkaOrMarzha = (originalPrice, skidka, isMarzha, precision = 0) => {
  const factor = 10 ** precision;
  const round = (value) => Math.round(value * factor) / factor;
  if (!originalPrice || isNaN(originalPrice) || originalPrice === 0) return '';
  if (!skidka || skidka === '' || isNaN(skidka)) return round(originalPrice) || '';
  const parsedSkidka = parseFloat(skidka);
  return isMarzha
    ? round(originalPrice * (1 + parsedSkidka / 100))
    : round(originalPrice * (1 - parsedSkidka / 100));
};

module.exports = {
  calculateSkidkaOrMarzha,
  calculatePriceFromSkidkaOrMarzha,
};
